import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { useSupplyTargetingFormField } from './useSupplyTargetingFormField';

export const useSupplyTargetingSliderValidation = () => {
    const { value: hasSupplyTargeting } = useSupplyTargetingFormField();
    const { value: includedSites } = useFormFieldValue({ field: 'campaignTargeting.publisherTargeting.include' });
    const { value: excludedSites } = useFormFieldValue({ field: 'campaignTargeting.publisherTargeting.exclude' });

    const hasIncludedSites = !!includedSites?.length;
    const hasExcludedSites = !!excludedSites?.length;
    const hasSiteTargeting = hasIncludedSites || hasExcludedSites;
    return hasSupplyTargeting && hasSiteTargeting;
};
